module.exports = __webpack_public_path__ + "img/logo.f06bb93b.png";